import React, { useContext } from "react";
import CounterRate from "./CounterRate";
import ForwardersContext from "../forwarders/ForwardersContext";
const ForwarderMetricContainer = ({ forwarderId }) => {
  const { getForwarderContext } = useContext(ForwardersContext);
  const { metrics: forwarderMetrics } = getForwarderContext(forwarderId);
  const hasResults = forwarderMetrics.length > 0;
  if (!hasResults) {
    return /* @__PURE__ */ React.createElement("span", null, "Not available");
  }
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(CounterRate, { metric: forwarderMetrics[0], suffix: "msg/s" }));
};
export default ForwarderMetricContainer;
